import { useUser } from 'src/Hooks/useUser'
import { useTypedSelector } from 'src/State/RootReducer'
import { hasAccessToDirectMarketing } from '../../utils'
import { isSoftwareVersionSupported, useSoftwareVersion } from 'src/Libs/home-power-station'

/**
 * Hook to check if the user has access to tibber based on feature flags, software version and direct marketing access
 */
const useExtensionAccess = (
  isExtensionFeatureFlagEnable: boolean,
  softwareSupportYear: string,
  softwareSupportMonthPatch: string
): { hasAccess: boolean } => {
  const currentInstallation = useTypedSelector(state => state.storage.installation)
  const { softwareVersion } = useSoftwareVersion()
  const { userData } = useUser()

  if (!isExtensionFeatureFlagEnable) return { hasAccess: false }

  if (!softwareVersion || !isSoftwareVersionSupported(`${softwareSupportYear}.${softwareSupportMonthPatch}`, softwareVersion)) {
    return { hasAccess: false }
  }

  if (!hasAccessToDirectMarketing(currentInstallation, userData)) return { hasAccess: false }

  return { hasAccess: true }
}

export default useExtensionAccess
